// @ngInject
function enterAsTab() {
    return function(scope, element, attrs) {
        element.bind("keydown keypress", function(event) {
            var fields = $(this).parents('form:eq(0), body').find('input.enterAsTab, textarea.enterAsTab, select.enterAsTab, ui-select.enterAsTab');
            var index = fields.index(this);

            if (event.which === 13 && event.shiftKey) {
                event.preventDefault();
                if (index > -1 && (index - 1) >= 0) {
                  fields.eq(index - 1).focus().select();
                }
            } else if (event.which === 13) {
                event.preventDefault();
                if (index > -1 && (index + 1) < fields.length) {
                  fields.eq(index + 1).focus().select();
                }
            }
        });
    };
}

// Moves the focus to the next input area instead of submitting the form.
angular.module('directives.enterAsTab', [])
    .directive('enterAsTab', enterAsTab);
